import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './GoogleSyncManager.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import { GoogleSyncSettings } from "../../moreCore/System/GoogleSyncTypes";


class GoogleSyncManager extends compose(_WidgetBaseSP) {
    templateString: any = template;

    protected syncStatusNode: HTMLDivElement;
    protected btnConnectGoogleAccount: HTMLButtonElement;
    protected cbEnableBacksyncPrivateAppointments: MdsLax<InstanceType<typeof CheckBox>>;
    protected cbEnableShowGoogleAppointmentsInEvis: MdsLax<InstanceType<typeof CheckBox>>;

    private _statusIntervalHandle;


    protected _onChange_Settings_Any(): void {
        this.StandbyStart();

        let settingsObject = {
            settings: {
                "BackSyncPrivateAppointments": this.cbEnableBacksyncPrivateAppointments.getChecked(),
                "ShowGoogleAppointmentsInEvis": this.cbEnableShowGoogleAppointmentsInEvis.getChecked(),
            }
        };

        this.RequestManager.callfunction("Webtool_API_GoogleSync__SetSyncSettings", settingsObject, lang.hitch(this, this._onSaveSyncSettingsResponse), lang.hitch(this, this._onSaveSyncSettingsError), true);
    }

    protected _onSaveSyncSettingsResponse(response: GoogleSyncSettings): void {
        this.StandbyStop();
    }

    protected _onSaveSyncSettingsError(err): void {
        this.StandbyStop();
        
        this.showToast(err.Message, toasterIcons.error);
    }

    protected _loadSyncSettings(): void {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API_GoogleSync__GetSyncSettings", {}, lang.hitch(this, this._onLoadSyncSettingsResponse), lang.hitch(this, this._onLoadSyncSettingsError));
    }

    protected _onLoadSyncSettingsResponse(syncSettings: GoogleSyncSettings): void {
        this.StandbyStop();
        //console.log("syncSettings", syncSettings);

        this.cbEnableBacksyncPrivateAppointments.setValue(syncSettings.BackSyncPrivateAppointments, true);
        this.cbEnableShowGoogleAppointmentsInEvis.setValue(syncSettings.ShowGoogleAppointmentsInEvis, true);
    }

    protected _onLoadSyncSettingsError(error): void {
        this.StandbyStop();
    }

    protected _checkStatus(): void {
        this.RequestManager.callfunction("Webtool_API_GoogleSync__IsSyncEnabled", {}, lang.hitch(this, this.onCheckStatusResponse), lang.hitch(this, this.onCheckStatusError));
    }

    protected onCheckStatusResponse(response: { enabled: boolean }): void {

        this.syncStatusNode.innerText = (response.enabled === true) ? this.translate("GoogleSyncManager_Connected") : this.translate("GoogleSyncManager_NotConnected");

        this.hideNode(this.btnConnectGoogleAccount, response.enabled);
        
    }

    protected onCheckStatusError(error): void {

    }

    protected _onClick_ConnectGoogleAccount(): void {
        this.RequestManager.callfunction("Webtool_API_GoogleSync__GetAuthLink", {}, lang.hitch(this, this.onConnectAccountResponse), lang.hitch(this, this.onConnectAccountError));
    }

    protected onConnectAccountResponse(response: { link: string }) {
        window.open(response.link);
    }

    protected onConnectAccountError(): void {

    }

    protected onSyncCalendarResponse(response): void {
        this.StandbyStop();
    }

    protected onSyncCalendarError(): void {
        this.StandbyStop();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._checkStatus();
        this._loadSyncSettings();

        this._statusIntervalHandle = setInterval(lang.hitch(this, this._checkStatus), 5000);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);

        clearInterval(this._statusIntervalHandle);
    }
}

export default mdsWidget(GoogleSyncManager);